<template>
  <div class="main_wrap">
    <div id="doLogin">
      <div>
        <ul class="bg">
          <li
            
            :class="[index == 0 ? 'show' : '']"
            :style="{ backgroundImage: 'url(' + require('../../static/images/bg1.jpg') +')' }"
          ></li>
          <li
            :class="[index == 1 ? 'show' : '']"
            :style="{ backgroundImage: 'url(' + require('../../static/images/bg2.jpg') +')' }"
          ></li>

        </ul>
      </div>
      <div class="login">
        <div class="title-box">天津市教育系统网络安全和舆情管控应急指挥平台</div>
        <div class="login-box">
          <p class="login-title">欢迎登录</p>
          <div class="login-form" style="margin-top: 20px;">
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <!-- 用户名 -->
              <el-form-item label-width="0" prop="username">
                <div style="display: flex;">
                  <div class="ico username"></div>
                  <el-input type="username" placeholder="用户名" v-model="ruleForm.username" autocomplete="off"></el-input>
                </div>
              </el-form-item>
              <!-- 密码 -->
              <el-form-item label-width="0" prop="password">
                <div style="display: flex;">
                  <div class="ico password"></div>
                  <el-input type="password" placeholder="密码" v-model="ruleForm.password" autocomplete="off"></el-input>
                </div>
              </el-form-item>
              <!-- 验证码 -->
              <el-form-item label-width="0" prop="verifyCode">
                <div style="display: flex;">
                  <el-input placeholder="验证码"  v-model="ruleForm.verifyCode"></el-input>
                  <img :src="path" id="code" @click="getVerifyCode">
                </div>
              </el-form-item>
              <!-- 提交按钮 -->
              <el-form-item label-width="0" >
                <el-button
                  @click ="submitForm('ruleForm')"
                  type="primary"
                  style="width: 100%;background: #0F2847;border: none; color: #fff;margin-top: 10px;height: 40px;cursor: pointer;"
                >登录</el-button>
              </el-form-item>
            </el-form>



            <div class="app-download">
              <div class="ico phone"></div>手机客户端下载
              <img class="ewm" src="../assets/images/ewm.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div>
        <ul class="cir">
          <li>
            <span :class="[index == 0 ? 'show' : '']"></span>
          </li>
          <li>
            <span :class="[index == 1 ? 'show' : '']"></span>
          </li>
          <!-- <li>
            <span :class="[index == 2 ? 'show' : '']"></span>
          </li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import * as loginAPI from "@/api/login.js";
import config from '../../config/config'
import md5 from 'js-md5'
import qs from 'qs'
export default {
  data() {
    return {
      path:config.baseUrl+'/api/verifyCode/verifyCode',// 图片验证码的获取地址
      index: 0, // 切换图片的下标
      ruleForm: {
        username: "",
        password: "",
        verifyCode: ""
      },
      rules: {
        username: [
          { required: true, trigger: 'blur',message: "用户名不能为空" }
        ],
        password: [
          { required: true,trigger: 'blur',message: "密码不能为空" }
        ],
        verifyCode: [
          {required: true, trigger: 'blur',message: "验证码不能为空" }
        ]
      }
    };
  },
  created() {
    setInterval(() => {
      if (this.index == 1) {
        this.index = 0;
      } else {
        this.index = this.index + 1;
      }
    }, 10000);
  },
  methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let data = {
              loginName: this.ruleForm.username,
              password:md5(this.ruleForm.password),
              verifyCode:this.ruleForm.verifyCode,
              clientType:"PC"
            }
            loginAPI.doSsoLogin(qs.stringify(data)).then(res => {
               if(res.code == 0) {
                this._util.setStorage("ssoUserInfo",res.data)
                let firstLogin = this._util.getStorage('firstLogin')
                console.log(firstLogin)
                if (res.data.updatePwdDays >= 173 && res.data.updatePwdDays <= 180) {
                  this.$confirm('密码使用周期为180天！请修改密码！', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '暂不',
                    type: 'warning'
                  }).then(() => {
                    this.$router.push({
                      path: '/Set/userinfo'
                    })  
                  }).catch(() => {
                    this.$router.push({
                      path: '/loginIndex'
                    })        
                  });
                } else if(!firstLogin) {
                  this._util.setStorage("firstLogin",1)
                  this.$confirm('初次登录请修改初始密码！', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '暂不',
                    type: 'warning'
                  }).then(() => {
                    this.$router.push({
                      path: '/Set/userinfo'
                    })  
                  }).catch(() => {
                    this.$router.push({
                      path: '/loginIndex'
                    })        
                  });
                } else {
                  this.$router.push({
                    path: '/loginIndex'
                  })    
                }
                // this.$router.push({
                //   path: '/loginIndex'
                // })
              } else {
                this.getVerifyCode()
                this.$message.error(res.msg);
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 获取验证码接口
      getVerifyCode(){
        this.path = config.baseUrl+'/api/verifyCode/verifyCode?time='+new Date().getTime()
      },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login {
  height: 100vh;
  width: 100%;
  background-size: cover;
  /* transition: all 2s; */
  position: relative;
}
.login .login-box {
  position: absolute;
  left: 20%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 350px;
  height: 400px;
  background: rgba(255, 255, 255, 0.8);
  box-sizing: border-box;
  padding: 25px;
  border-radius: 10px;
}
.login .login-box .login-title {
  margin-top: 15px;
  text-align: center;
  font-size: 22px;
}
input {
  outline: none;
  border: none;
  flex: 1;
  box-sizing: border-box;
  padding-left: 20px;
}
.ico {
  width: 46px;
  height: 40px;
}
.ico.username {
  background: #cdcdcd url("../assets/images/username.png") no-repeat center
    center / 25px 25px;
}
.ico.password {
  background: #cdcdcd url("../assets/images/password.png") no-repeat center
    center / 25px 25px;
}
.ico.phone {
  background: url("../assets/images/phone.png") no-repeat center center / 25px
    25px;
  margin-left: -20px;
}
.app-download {
  width: 200px;
  height: 40px;
  margin: 20px auto;
  background: rgba(0, 0, 0, 0.4);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  position: relative;
  cursor: pointer;
}
.app-download:hover .ewm {
  display: block;
}
.title-box {
  font-size: 28px;
  color: #fff;
  position: relative;
  left: 5%;
  top: 5%;
  display: inline-block;
}
.bg li {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-size: cover;
  transition: all 1s;
  opacity: 0;
}
.bg li.show {
  opacity: 1;
}
.cir {
  position: absolute;
  left: 50%;
  bottom: 5%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  width: 150px;
  margin: 0 auto;
}
.cir li {
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.cir li span {
  display: inline-block;

  margin: 0 auto;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  /* margin-right: 50px; */
  background: #f0f0f0;
}
#code {
  height: 40px;
  width: 90px;
  margin-left: 10px;
}
.cir span.show {
  background: #409eff;
}
.ewm {
  position: absolute;
  z-index: 100;
  width: 150px;
  left: 25px;
  top: -150px;
  display: none;
}
#doLogin >>> .el-input__inner:focus {
  border: none !important;
}
#doLogin >>> .el-input__inner {
  border-radius: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue